var imgArr = new Array();
var imgObj = new Object();
var url;
var alt;
var how_many_ads;
var banner;
var txt;
function ImgObj(resetarr,url,alt,banner,txt,action){
	if(resetarr == 1){
		imgArr.length = 0;
	}
	this.url = url;
	this.alt = alt;
	this.banner = banner;
	this.txt = txt;
	this.action = action;
	this.how_many_ads = imgArr.length;
}
function addImg(img_obj){
	var i = imgArr.length;
	imgArr[i]= img_obj;	
	//alert("url = " + imgArr[i].url + ' \n num of imgs: ' + imgArr[i].how_many_ads);
	
}

function displayBanner(){
    var now = new Date();
    var sec = now.getSeconds();
    var ad = sec % imgArr.length;
                   
    var width="315";
    var height="185";
   
    document.write('<center>');
    document.write('<a href=\"' + imgArr[ad].url + '\" target=\"_top\">');
    document.write('<img src=\"' + imgArr[ad].banner + '\" width=')
    document.write(width + ' height=' + height + ' ');
    document.write(' onClick=\"' + imgArr[ad].action + '\" ');
    document.write('alt=\"' + imgArr[ad].alt + '\" border=0><br>');
    document.write('<small>' + imgArr[ad].txt + '</small></a>');
    document.write('</center>');
}            